import React, { memo, useState, useEffect, useCallback } from 'react'
import { Form, Select, Space } from 'antd'
import styles from '../../index.module.less'
import selfStyles from './index.module.less'
import { LayoutEnum } from '../../enum'

const Index = (props: any) => {
  const { field, onChange, value } = props
  const {
    width,
    label,
    placeholder = '请选择',
    layout,
    options,
    defaultValue,
    allowClear,
    showSearch,
    optionFilterProp = 'label',
    multiple,
    selectConfig,
  } = field

  // const [inputValue, setInputValue] = useState('')
  const triggerChange = v => {
    onChange?.(v)
  }
  const handleInputValueChange = v => {
    triggerChange(v)
  }
  return (
    <div className={styles.innerFieldWrap}>
      {layout === LayoutEnum.HORIZONTAL ? (
        <Space.Compact block>
          {/* <div className={styles.addon}>{label}</div> */}
          {label && <div className={styles.addon}>{label}</div>}
          <Select
            className={selfStyles['select']}
            optionFilterProp={optionFilterProp}
            showSearch={showSearch}
            allowClear={allowClear}
            value={value}
            style={{ width }}
            placeholder={placeholder || `请选择${label}`}
            options={options}
            mode={multiple}
            onChange={handleInputValueChange}
            {...selectConfig}
          />
        </Space.Compact>
      ) : (
        <div className={styles.vertical}>
          {/* <div className={styles.addon}>{label}</div> */}
          {label && <div className={styles.addon}>{label}</div>}
          <Select
            className={selfStyles['select']}
            optionFilterProp={optionFilterProp}
            showSearch={showSearch}
            maxTagCount={1}
            allowClear={allowClear}
            value={value}
            style={{ width }}
            placeholder={placeholder || `请选择${label}`}
            options={options}
            mode={multiple}
            onChange={handleInputValueChange}
            {...selectConfig}
          />
        </div>
      )}
    </div>
  )
}

export default Index
